module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key)) { return null; }
        if (!$event.ctrlKey) { return null; }
        _vm.speak($event)
      },
      "click": _vm.disableSpeak
    }
  }, [_c('md-tabs', {
    staticClass: "md-transparent",
    on: {
      "change": _vm.changed
    }
  }, _vm._l((_vm.opt), function(o) {
    return _c('md-tab', {
      key: o.value,
      attrs: {
        "id": o.value,
        "md-label": o.text,
        "md-active": _vm.selected == o.value
      }
    }, [(_vm.selected == o.value) ? [_c('input', {
      attrs: {
        "type": "hidden",
        "name": _vm.sel_name
      },
      domProps: {
        "value": _vm.selected
      }
    }), _vm._v(" "), _vm._l((_vm.custom), function(c) {
      return (_vm.selected == c.value) ? _c('div', {
        key: c.value
      }, [_c('simple-element', {
        attrs: {
          "el": c.el
        }
      })], 1) : _vm._e()
    })] : _vm._e()], 2)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56634061"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomTabs.vue
// module id = 454
// module chunks = 1